import React, { PureComponent } from "react";
import { NavLink as RouteLink } from "react-router-dom";
import PropTypes from "prop-types";
import "./Card.css";

class Card extends PureComponent {
  render() {
    return (
      <div className="card mx-auto text-center">
        <img
          className={this.props.rounded ? "mx-auto rounded-circle" : "mx-auto"}
          src={this.props.src}
          alt=""
        />
        <div className="card-block" style={{ color: this.props.textColor }}>
          <h3 className=" card-title"> {this.props.title} </h3>
          <p className="section-text card-text"> {this.props.text} </p>
        </div>
        <div
          className="card-footer"
          style={{ background: this.props.footerColor }}
        >
          <RouteLink
            onClick={this.props.onClick}
            to={this.props.to}
            className={
              "col-12 col-xl-8 mx-auto text-center readMore " +
              this.props.button
            }
          >
            Read more
          </RouteLink>
        </div>
      </div>
    );
  }
}
Card.propTypes = {
  src: PropTypes.string,
  rounded: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
  footerColor: PropTypes.string,
  button: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string
};
Card.defaultProps = {
  src: null,
  rounded: null,
  title: null,
  text: null,
  textColor: null,
  footerColor: null,
  button: null,
  onClick: null,
  to: null
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Cards/Card/Card.jsx